import axios from 'axios';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import AlertLabel from '../../component/AlertLabel';
import BlockUI from '../../component/BlockUI';
import { RenderSearchForm } from '../../component/formInput';
import Pagination from '../../component/Pagination';
import DCServerModal from './modal/DCServerModal';

var _ = require('lodash');

function ServerRows(data, handleShowModal){
  const inner_rows = _.map(data, (i, index) => {
    return <tr key={index}>
        <td>{i.server_name}</td>
        <td>{i.ip_address}</td>
        <td>{i.server_core}</td>
        <td>{i.vcore}</td>
        <td>{i.core_used}</td>
        <td>{i.server_ram}</td>
        <td>{i.vram}</td>
        <td>{i.ram_used}</td>
        <td>{i.server_hdd}</td>
        <td>{i.hdd_used}</td>
        <td>{i.dc_u}</td>
        <td>
          <div className="icons-list">
            <div className="dropdown">
              <a href="#" className="list-icons-item" data-toggle="dropdown">
                <i className="icon-menu9"></i>
              </a>
              <div className="dropdown-menu dropdown-menu-right">
                <a onClick={()=> handleShowModal(i)} className="dropdown-item">
                  <i className="icon-pencil"></i> Chỉnh sửa
              </a>
              </div>
            </div>
          </div>
        </td> 
      </tr>
  })
  return inner_rows;
}

class DCServerTable extends React.Component {
  constructor(props) {
    super(props);
    const {product_type} = this.props.routeProps.match.params;
    this.state = {
      table_data: [],
      table_query: {
        current_page: 1,
        number_of_row: 20,
        product_type: product_type,
        search_field: "search",
        search_value: "",
        alert_label: null,
      },
      dc_server_selected: null,
      is_show_modal: false,
      is_loading: true
    }
  }

  componentDidMount() {
    this.listReload(this.state.table_query);
  }

  gotoPage = (page) => {
    this.setState({
      is_loading: true
    })
    const table_query = {
      ...this.state.table_query,
      current_page: page
    };
    this.listReload(table_query);
  }
  
  // Lấy danh sách sản phẩm  
  listReload = (table_query) => {
    const self = this;
    axios({
      method: 'post',
      url: window.api_url + '/admin/api/dc_server/list',
      withCredentials: true,
      data: table_query
    }).then(function (response) {
      self.setState({
        ...self.state,
        table_query: table_query,
        table_data: response.data.data,
        is_loading: false
      })
    });
  }
  
  handleShowModal = (product) => {
    this.setState({
      is_show_modal: true,
      dc_server_selected: product
    })
  }

  handleHideModal = () => {
    
    this.setState({
      is_show_modal: false,
      dc_server_selected: null, 
      is_loading: true
    })
    this.listReload(this.state.table_query)
  }

  onSearchSubmit = (values) => {
    const search_value = values.search ? values.search : "";
    const { history } = this.props;
    this.setState({
      is_loading: true
    })
    const table_query = {
      ...this.state.table_query,
      search_value: search_value,
      current_page: 1,
      invoice_status: "all"
    };
    history.push("/admin/server/list?search=" + search_value);
    this.listReload(table_query);
  }

  clearDataFilter = () => {
    const { reset, history } = this.props;
    const self = this;
    this.setState({
      is_loading: true
    })
    const table_query = {
      ...this.state.table_query,
      search_value: "",
      current_page: 1
    };
    reset();
    history.push("/admin/server/list");
    this.listReload(table_query);
  }
  
  onKeyPess = (key_code) => {
    if (key_code == "Escape") {
      this.clearDataFilter();
    }
  }

  render() {
    const { handleSubmit } = this.props;
    const {table_query, table_data, alert_label, is_show_modal, dc_server_selected, is_loading} = this.state;
    return(
      <React.Fragment> 
        {is_loading && <BlockUI />}
        <div className="page-header">
          <h4>
            <i className="icon-paragraph-justify2"></i>
            <span className="text-semibold"> Danh sách Server</span>
          </h4>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card card-body">
              <form style={{display:"inline-flex"}} onSubmit={handleSubmit(this.onSearchSubmit)}>
                <div style={{ width:"100%", paddingRight:5}}>
                  <Field
                    name="search"
                    placeholder="Tìm kiếm theo IP Address"
                    defaultValue = {table_query.search_value}
                    onKeyAction={(ev)=> this.onKeyPess(ev)}
                    component={RenderSearchForm}
                  />
                </div>
              </form>
            </div>
            <button onClick={()=>this.handleShowModal()} className="btn bg-primary" style={{float: "right"}}>+ Thêm Mới</button>
          </div>
        </div>
        <br/>
        <div className="row">
          <div className="col-md-12">
            {alert_label && <AlertLabel status = {alert_label.status} message = {alert_label.message}/>}
            <div className="card">
              <div className="table-responsive">
                <table className="table table-togglable table-hover default footable-loaded footable">
                  <thead>
                    <tr>
                      <th>Tên Server</th>
                      <th>IP</th>
                      <th>Core</th>
                      <th>V-Core</th>
                      <th>Used Core</th>
                      <th>Ram</th>
                      <th>V-Ram</th>
                      <th>Used Ram</th>
                      <th>HDD</th>
                      <th>Used HDD</th>
                      <th>Mã U Tủ Rack</th>
                      <th className="text-center footable-visible footable-last-column" style={{width: "30px"}}>
                        <i className="icon-menu-open2"></i>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {table_data && ServerRows(table_data.data, this.handleShowModal)}
                  </tbody>
                </table>
              </div>
            </div>
            <Pagination query={table_query} data={table_data} handle={this.gotoPage}/>
          </div>
          {is_show_modal && <DCServerModal dcServerObj={dc_server_selected} show={is_show_modal} onHide={this.handleHideModal} />}
        </div>
      </React.Fragment>
    )
  }
}

const DCServerTableWrapper = reduxForm({
  form: 'DCServerTable',
  destroyOnUnmount: true,
  enableReinitialize: true,
})(DCServerTable);

export default withRouter(DCServerTableWrapper);